export const black = '#000000';
export const white = '#ffffff';
export const ice = '#dfe6f0';
export const chambray = '#2e4487';
export const malibu = '#79b7ff';
export const gallery = '#f0f0f0';
export const cod = '#1a1a1a';
